<script>
	// Stores 
	import { textSite, mailCadastro } from '../store.js'; 

	// Componentes
	import { Router, Link, link , Route } from "svelte-routing";
	import PageHeader from "../components/PageHeader.svelte";
	import Forms from "../components/Forms.svelte";

	// Code
	let titlePage = 'Enviar Cadastro ';    

	let fields = [
		{
			title:  'Nome *',
			name:   'nome',
			required: 'required',
		},
		{
			title:  'Telefone *',
			name:   'telefone',
			required: 'required',
			classe: 'mask-telefone'
		},
		{
			title:  'Email *',
			name:   'email',
			type: 'email',
			required: 'required',
		},
		{
			title:  'Anexos',
			name:   'enviarcadastro-anexos',
			type: 'fileinput',
			maxFileCount: 10,
			minFileCount: 1,
			allowedFileTypes: ['pdf']
		},
	];      
	
	const message = `
Nome: {nome}
Telefone: {telefone}
Email: {email}

{info}
	`;

	let loading = false;
	function send() {
		loading = true;
	}    

</script>

<PageHeader title={titlePage}></PageHeader>

<div class="container">
	<div class="text-center">
		<p>
			Utilize o formulário abaixo para enviar a documentação necessária para cadastramento.
		</p>
	</div>
	<div class="offset-md-3 col-md-6 pl-0 pr-0">    
		<hr class="line-separator">
		<Forms fields={fields} destiny={$mailCadastro} subjectTitle="{titlePage}" {message} htmlbody={false} />
	</div>
</div>